<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <form class="form" [formGroup]="model"  (ngSubmit)="submit()">
        <div class="row">
            <div class="col-sm-6">
                <h1 class="title-default">Cadastrar Relatório</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Título do Relatório</mat-label>
                    <input matInput formControlName="tituloRelatorio" type="text">
                    @if (model.get('tituloRelatorio')?.invalid) {
                        <mat-error>Informe o título do relatório</mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="col-md-6">
               <mat-form-field appearance="outline">
                   <mat-label>Perfil com Acesso</mat-label> 
                   <mat-select  formControlName="listaIdPerfil" multiple>
                       @if(_usuarioLookupResponse){
                           @for (perfil of _usuarioLookupResponse.listaPerfil; track perfil) {
                               <mat-option [value]="perfil.idPerfil">{{perfil.nome}}</mat-option>
                             }
                       }
                   </mat-select>             
               </mat-form-field>
           </div>  
        </div>
        <div class="row">
           
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Link do Relatório</mat-label>
                    <input matInput formControlName="linkRelatorio" type="text">
                    @if (model.get('url')?.invalid) {
                     <mat-error>Informe um link do relatório</mat-error>
                 }
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
               <button type="submit" mat-flat-button class="btn-primary button-big">
                     @if (_isLoading === true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                     }
                     @else{
                        Salvar
                     }
               </button>
            </div>
        </div>
    </form>
</div>